import {
  Body3,
  Color,
  FontSize,
  ResponsiveValue,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';
import { InlineLink } from '../InlineLink/InlineLink';

const LINK_SIZE: ResponsiveValue<FontSize> = [0, null, 2];

const Footnote = withCitrusTheme('section', (theme) => ({
  maxWidth: '1020px',
  margin: '0 auto',
  marginTop: theme.spacing(6),
}));

export type ComparisonMethodologyFootnoteProps = {
  readonly backgroundStyle: 'light' | 'dark';
};

export function ComparisonMethodologyFootnote({
  backgroundStyle,
}: ComparisonMethodologyFootnoteProps): JSX.Element {
  const textColor = backgroundStyle === 'dark' ? Color.White : Color.ColdGrey_800;

  return (
    <Footnote aria-label="Comparison table methodology">
      <Body3 color={textColor}>
        Correct as of September 2026. Prices are the lowest price per portion, excluding delivery.
        Recipe numbers are from each brand&rsquo;s weekly menu. See how we checked:{' '}
        <InlineLink
          backgroundStyle={backgroundStyle}
          size={LINK_SIZE}
          href="https://cook.gousto.ie/value/"
          target="_blank"
          rel="noopener noreferrer"
        >
          prices
        </InlineLink>
        ,{' '}
        <InlineLink
          backgroundStyle={backgroundStyle}
          size={LINK_SIZE}
          href="https://gousto.ie/choice/"
          target="_blank"
          rel="noopener noreferrer"
        >
          recipe choice
        </InlineLink>{' '}
        and{' '}
        <InlineLink
          backgroundStyle={backgroundStyle}
          size={LINK_SIZE}
          href="https://cook.gousto.irish/10-minute-meals/"
          target="_blank"
          rel="noopener noreferrer"
        >
          10-minute recipes
        </InlineLink>
        .
      </Body3>
    </Footnote>
  );
}
